<template>
    <v-app-bar tile
               app
               clipped-left
               height="75"
               class="member_app_header"
               color="white">

        <v-app-bar-nav-icon @click.stop="cycleDrawerMenu"></v-app-bar-nav-icon>

        <div class="d-flex justify-sm-space-between justify-end" style="width: 100%;">

            <v-tooltip color="primary" top open-delay="1000">
                <template v-slot:activator="{ on }">
                    <v-img v-if="config.header_logo_enabled"
                           v-on="on"
                           max-height="75"
                           max-width="225"
                           contain
                           class="hidden-xs-only mr-2"
                           :aspect-ratio="9/3"
                           :src="logoUrl"/>
                </template>
                Build: {{ $store.state.Community.build }}
            </v-tooltip>

            <v-fade-transition>
                <div v-show="showWelcome" class="ml-2 hidden-xs-only align-self-center" v-if="account">
                    <h2 class="grey--text text--darken-1 font-weight-medium">
                        {{ translations.welcome_text }} {{ account.first_name }}!
                    </h2>
                </div>
            </v-fade-transition>

            <div v-if="account && displayRewardPoints" class="d-flex align-end">
                <div class="pr-2 align-self-center">{{ translations.reward_points_text }}</div>
                <reward-points-box
                    class="align-self-center"
                    :value="account.points_balance"
                ></reward-points-box>
            </div>
        </div>

    </v-app-bar>
</template>

<script>

import {mapState} from 'vuex';
import RewardPointsBox from "@/modules/MemberApp/components/RewardPointsBox.vue";

const vuexModule = 'Community';

export default {

    name: "AppToolbar",

    components: {
        RewardPointsBox,
    },

    props: {
        translations: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            showWelcome: false,
        }
    },

    computed: {

        ...mapState(vuexModule, [
            'config',
            'account',
        ]),

        logoUrl() {
            if (this.config.header_logo_url) return this.config.header_logo_url;
            if (this.config.logo_url) return this.config.logo_url;
        },

        displayRewardPoints() {
            return this.config.display_reward_points;
        }
    },

    methods: {

        cycleDrawerMenu() {
            this.$emit('drawer:cycle')
        },
    },

    created() {

        Bus.$on('welcome', () => {

            setTimeout(() => {
                this.showWelcome = true
            }, 1000);

            setTimeout(() => {
                this.showWelcome = false;
            }, 7000);
        });
    }
}
</script>
